import type { CustomCellRendererProps } from 'ag-grid-react'
import { formatDateShort } from '@/utils/formatters'

export function GridDateCell(props: CustomCellRendererProps) {
  const value = props.value as string
  if (!value) return null

  return (
    <span className="text-sm text-foreground">{formatDateShort(value)}</span>
  )
}
